import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { MasterWorkout } from 'src/types/MasterWorkout'
import { MasterWorkoutExerciseLookups } from 'src/types/MasterWorkoutExercise'
import MasterWorkoutExerciseViewModel from 'src/viewmodels/MasterWorkoutExerciseViewModel'
import CreateOrEditMasterWorkoutExerciseForm from './CreateOrEditMasterWorkoutExerciseForm'

interface CreateOrEditMasterWorkoutExerciseProps {
	masterWorkout: MasterWorkout
	masterWorkoutExerciseViewModel: MasterWorkoutExerciseViewModel
	lookups: MasterWorkoutExerciseLookups
	masterWorkoutWeightSelection: string
	canEdit: boolean
}

const CreateOrEditMasterWorkoutExercise: React.FC<CreateOrEditMasterWorkoutExerciseProps> = observer(
	({ masterWorkoutExerciseViewModel, masterWorkout, lookups, masterWorkoutWeightSelection, canEdit }) => {
		const { masterWorkoutExercise, submitMasterWorkoutExercise, validateMasterWorkoutExercise } = masterWorkoutExerciseViewModel

		const initialValues = useMemo(() => {
			return { ...masterWorkoutExercise }
		}, [masterWorkoutExercise.id, masterWorkoutExercise.day, masterWorkoutExercise.week, masterWorkoutExercise.displayOrder])

		return (
			<CreateOrEditMasterWorkoutExerciseForm
				initialValues={initialValues}
				masterWorkout={masterWorkout}
				onSubmit={submitMasterWorkoutExercise}
				onValidate={validateMasterWorkoutExercise}
				lookups={lookups}
				masterWorkoutWeightSelection={masterWorkoutWeightSelection}
				canEdit={canEdit}
			/>
		)
	},
)

export default CreateOrEditMasterWorkoutExercise
